// const developHost = 'http://192.168.2.25:3000/mock/13/marketingplus'
// export const developHost = 'http://120.78.175.175'

// export const developHost = 'http://192.168.22.253:8080/'

//export const productionHost = 'https://daworker.gimc-auto.com'
// export const productionHost = 'http://120.78.175.175'
// const develop = `${developHost}/marketingplus`
// const production = `${productionHost}/marketingplus`
export const host = `${process.env.VUE_APP_BASE_API}/marketingplus`
